import PpobService from '@/services/ppob'
import { nominals, product } from '@/assets/utils/ppob'

export default {
  getPrabayar ({commit}, params) {
    return new Promise((resolve, reject) => {
      PpobService.getPrabayar({
        params,
        headers: {
          'Authorization': localStorage.token
        }
      })
        .then(response => {
          commit('SET_DATA_PRABAYAR', response.data.data)
          resolve({products: response.data.data, recordsTotal: response.data.recordsTotal})
        })
        .catch(e => reject(e))
    })
  },
  savePostpaid({commit}, payload) {
    return new Promise((resolve, reject) => {
      PpobService.savePostpaid(payload, {
        headers: {
          'Authorization': localStorage.token
        }
      })
      .then(response => resolve(response.data))
      .catch(e => reject(e))
    })
  }
}